/**************************************************
 * Nombre:       BotonCripto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {createRef, useEffect, useState} from "react";
import {Grid, InputAdornment, MenuItem, TextField} from "@mui/material";
import {CRIPTOS} from "../Constantes";
import {CurrencyBitcoin} from "@mui/icons-material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const BotonCripto = ({valor = 0, idPedido}) => {
    const {sCell} = useResponsive()
    const [criptoEscogida, setCriptoEscogida] = useState('')
    const [seleccion, setSelecciones] = useState(CRIPTOS.map((it) => it.nombre)[0])


    useEffect(() => {
        let index = CRIPTOS.findIndex((e) => e.nombre === seleccion)
        let esco = CRIPTOS[index]
        setCriptoEscogida(esco)

    }, [seleccion])
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >

            <Grid item container lg={9} sm={9} xs={12} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    label={'Paga con Criptomodeda'}
                    fullWidth
                    select
                    value={seleccion}
                    onChange={(e) => setSelecciones(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <CurrencyBitcoin color={'primary'}/>
                            </InputAdornment>
                        ),
                        disableUnderline: true,

                    }}
                >
                    {CRIPTOS.map((c, i) => (
                        <MenuItem key={`c-${i}`} value={c.nombre}>
                            {c.nombre}
                        </MenuItem>
                    ))}
                </TextField>

            </Grid>

            <Grid item container lg={3} sm={3} xs={12} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                <iframe
                    src={`https://boton.sarasty.com/?valor=${valor}&red=${criptoEscogida.red}&token=${criptoEscogida.token}&llave=${criptoEscogida.llave}&idPedido=${idPedido}`}
                    style={{border: 1, width: 200, height: 68, paddingLeft: sCell ? 30 : 0}}/>
            </Grid>

        </Grid>


    )

}
export default BotonCripto    